module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Akte2.d4e49730.png";